import(/* webpackMode: "eager" */ "/var/www/eduegoo/frontend/app/books/page.tsx");
